import { render, staticRenderFns } from "./ads-payment-method.vue?vue&type=template&id=9868339a"
import script from "./ads-payment-method.vue?vue&type=script&lang=js"
export * from "./ads-payment-method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports